'use client';
import { toast } from 'react-toastify';
import BaseTour from './tour/BaseTour';
import { TourType } from '@/_models/Tour';
import { getLocationUrl } from './util/getLocationUrl';

export default class PublicTour extends BaseTour {
  constructor(props: any) {
    super(props, TourType.Regular);
  }

  componentDidMount() {
    // For tours (not asset pages) we want to set overflow hidden
    // It avoids a bug where the scroll bar in Safari appears for a split second (TB-3322)
    if (document.documentElement && !document.location.pathname.includes('/asset/')) {
      document.documentElement.style.overflow = 'hidden';
    }

    const { tour, matterId, tourData } = this.props;
    if (!tourData?.tour) {
      toast.error('Tour not found');
      return;
    }

    // @ts-ignore
    window.tourId = tourData.tour.id;
    // @ts-ignore
    window.multiPath = [];

    const url = getLocationUrl();
    if (tour) {
      // preview of the tour, load from props
      this.loadData(tour);
    } else {
      this.getTour({
        slug: matterId,
        tourData,
        url,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.takePosition);
    document.removeEventListener('contextmenu', this.disableContext);
  }
}
